import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Button, Form, OverlayTrigger, Popover } from "react-bootstrap";
import { Link } from "react-router-dom";
import CustomConversions from "./CustomConversions";
import CustomTooltip from "utils/CustomTooltip";
import BackButton from "../BackButton";
import NextButton from "../NextButton";
import SkipButton from "../SkipButton";
import getNextPage from "../getNextPage";
import {RouterContext} from "../Onboarding"

export default function SocialConversions(props) {
  const route = useContext(RouterContext)

  const nextPage = getNextPage(props.onboarding_progress);

  useEffect(() => {
    window.localStorage.setItem(
      "routerHistory",
      JSON.stringify([...route.get])
    );
  }, [route.get]);
  props.pageLocator();
  const [validated, setValidatation] = useState(false);
  
  return (
    <>
      <Row className=" mb-1  justify-content-center">
        <Col md={7}>
          <div>
            <p className="pb-3 f28 visby-bold primary text-center">Social Conversions</p>
          </div>
          <div className="pb-3">
            <p className="f16 nunito-regular text-center primary ">Choose the account-level conversion objectives for Facebook & Tiktok.</p>
          </div>
        </Col>
      </Row>
      <Row>
        <Col className="py-3">
          <div style={{ margin: "0 auto", textAlign: "center", maxWidth: "500px" }}>
            <p className="f18 mb-3 text-info d-inline-block visby-bold">Facebook Objective </p>
            <CustomTooltip
              faClass="far text-info fa-question-circle pl-2"
              message="Here you can set the objective for facebook conversions. Choose one of the pre-made settings from the dropdown, or use the custom conversions option to be more specific and input your own conversion IDs and labels (labels are simply to make your IDs easier to identify within DataPulse)."
              inline={true}
            />
            <Form.Control
              className="primary mb-2 mx-auto"
              size="md"
              as="select"
              name="[facebook_conversion_objective]"
              value={props.facebookConversionObjective}
              onChange={(e) => {
                props.setFacebookConversionObjective(e.target.value);
                setValidatation(true);
              }}
              style={{ width: "256px", paddingLeft: "20px", marginLeft: "3px" }}>
              {}
              <option key="placegolder" value="" disabled>
                Choose Objective
              </option>
              {Object.keys(props.facebook_conversion_objectives).map((objectiveName) => {
                const objectiveInt = props.facebook_conversion_objectives[objectiveName];
                return (
                  <option key={objectiveInt} value={objectiveName}>
                    {capitalize(objectiveName.split("_").join(" "))}
                  </option>
                );
              })}
            </Form.Control>
            {props.facebookConversionObjective == "custom_conversions" && (
              <CustomConversions customConversions={props.facebookCustomConversions} setCustomConversions={props.setFacebookCustomConversions} />
            )}
          </div>
        </Col>
      </Row>
      <Row>
        <Col className="py-3">
          <div style={{ margin: "0 auto", textAlign: "center", maxWidth: "500px" }}>
            <p className="f18 mb-3 text-info d-inline-block visby-bold">Tiktok Objective </p>
            <CustomTooltip
              faClass="far text-info fa-question-circle pl-2"
              message="Choose which objective the Tiktok campaigns are targeting, typically 'Complete payment' for e-commerce and 'Complete registration' for Lead generation."
              inline={true}
            />
            <Form.Control
              className="primary mb-2 mx-auto"
              size="md"
              as="select"
              name="[tiktok_conversion_objective]"
              value={props.tiktokConversionObjective}
              onChange={(e) => {
                props.setTiktokConversionObjective(e.target.value);
                setValidatation(true);
              }}
              style={{ width: "256px", paddingLeft: "20px", marginLeft: "3px" }}>
              {}
              <option key="placegolder" value="" disabled>
                Choose Objective
              </option>
              {Object.keys(props.tiktok_conversion_objectives).map((objectiveName) => {
                const objectiveInt = props.tiktok_conversion_objectives[objectiveName];
                return (
                  <option key={objectiveInt} value={objectiveName}>
                    {capitalize(objectiveName.split("_").join(" "))}
                  </option>
                );
              })}
            </Form.Control>
          </div>
        </Col>
      </Row>
      <Row className="mt-5 ">
        <Col>
          <div className="navButtonRow">
            <BackButton />
            <SkipButton 
                btnText={`Skip for now`}
                nextPage={nextPage.url}
              />
            <NextButton
              validated={validated} 
              btnText={`Next`}
              nextPage={nextPage.url}
              invalidText={`We need more information on this page before you continue.`}
              submitForm={props.submitForm}
            />
          </div>
        </Col>
      </Row>
    </>
  );
}
